import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
const ip = process.env.REACT_APP_IP;
const LoginAuth = () => {
  const { loginWithRedirect, getAccessTokenSilently } = useAuth0();
  loginWithRedirect({ authorizationParams: { prompt: "login" } })

  return ;
};

export default LoginAuth;